export default __webpack_public_path__ + "static/artistBox-alias-anono-8d6d3b9edf4f8ee2c37ac44b46395da4.png";